import {Segmented } from "antd";
import React from "react";
import { useState } from "react";
import { CurrencyInput } from "./CurrencyInput";
import { SwapOutlined } from '@ant-design/icons';


import '../../css/currency-exchange.scss';
import peFlag from '../../img/flags/pe.png';
import usFlag from '../../img/flags/us.png';
import ueFlag from '../../img/flags/ue.png';


export function RateScreen({updateIsSwapped}) {
    const [currency, setCurrency] = useState('USD');

    const buyRate = currency==='USD'?3.3425:3.9212;
    const sellRate = currency==='USD'?3.3755:3.9782;

    const [lockedSide, setLockedSide] = useState('buy');
    const [rateSide, setRateSide] = useState(3.3425);
    
    const [fromAmount, setFromAmount] = useState(1000);
    const [toAmount, setToAmount] = useState(299.18);
    const [isSwapped, setIsSwapped] = useState(false);

    const [changeFrom, setChangeFrom] = useState(true);

    const from = isSwapped
        ? { label: 'Envía', code: currency, symbol: currency==='USD'?'$':'€', flag:currency==='USD'?usFlag:ueFlag }
        : { label: 'Envía', code: 'PEN', symbol: 'S/', flag:peFlag  };

    const to = isSwapped
        ? { label: 'Recibe', code: 'PEN', symbol: 'S/', flag:peFlag }
        : { label: 'Recibe', code: currency, symbol: currency==='USD'?'$':'€', flag:currency==='USD'?usFlag:ueFlag };

    const onChangeLockedSide = (value)=>{
        console.log(value);
        setLockedSide(value);
        const rate = value === 'buy'?buyRate:sellRate;
        setRateSide(rate);
        setIsSwapped(!isSwapped);
        updateIsSwapped(!isSwapped);        
        const to = calculateAmount(fromAmount, rate, true, !isSwapped);
        setToAmount(to);
    }

    const onChangeCurrency = (value)=>{
        setCurrency(value);
        setLockedSide('buy');
        const rate = value==='USD'?3.3425:3.9212;
        setRateSide(rate);
        setIsSwapped(false);
        updateIsSwapped(false);
        setChangeFrom(true);
        const to = calculateAmount(fromAmount, rate, true);
        setToAmount(to);
    }

    const calculateAmount = (amount, rateSide, changeFrom, isSwapped) => {

        const rate = changeFrom ? (isSwapped ? rateSide : 1/rateSide) :(isSwapped ?  1/rateSide: rateSide);

        return (Number(amount || 0) * rate).toFixed(2);
    }

    const changeFromAmount = (value) =>{
        setFromAmount(value);
        if(changeFrom)
        {
            const to = calculateAmount(value, rateSide, true, isSwapped);
            setToAmount(to);
        }
    }

     const changeToAmount = (value) =>{
        setToAmount(value);

        if(!changeFrom){
            const from = calculateAmount(value, rateSide, false, isSwapped);
            setFromAmount(from);
        }
    }


    return <>
        <div>
            <Segmented
                value={lockedSide}
                onChange={onChangeLockedSide}
                options={[
                    {
                    label: `Compra S/ ${buyRate}`,
                    value: 'buy',
                    },
                    {
                    label: `Venta S/ ${sellRate}`,
                    value: 'sell',
                    },
                ]}
                style={{
                    backgroundColor: '#E9EDF5',
                    padding: 6,
                    borderRadius: 24,
                    marginBottom:20
                }}
                />

            <Segmented
                value={currency}
                onChange={onChangeCurrency}
                options={[
                    {
                    label: <div>
                                <img
                                    src={usFlag}
                                    alt={'USD'}
                                    className="flag"
                                />
                            </div>,
                    value: 'USD',
                    },
                    {
                    label: <div>
                                <img
                                    src={ueFlag}
                                    alt={'EUR'}
                                    className="flag"
                                />
                            </div>,
                    value: 'EUR',
                    },
                ]}
                style={{
                    backgroundColor: '#E9EDF5',
                    padding: 6,
                    borderRadius: 24,
                    marginBottom:20,
                    marginLeft: 20
                }}
                />

                <div className="exchange-wrapper">
                <CurrencyInput
                    {...from}
                    amount={fromAmount}
                    editable
                    onChange={changeFromAmount}
                    onFocus={()=> setChangeFrom(true)}
                />

                <button className="swap-btn" onClick={()=>onChangeLockedSide(lockedSide === 'buy'?'sell':'buy')}>
                    <SwapOutlined />
                </button>

                <CurrencyInput
                    {...to}
                    amount={toAmount}
                    editable={true}
                    onChange={changeToAmount}
                    onFocus={()=> setChangeFrom(false)}
                />
                </div>
        </div>    
    </>


}
